import React from "react";
import { COOKIE_KEY } from "./CookieConsent";


const CURRENT_YEAR = new Date().getFullYear();

const links = [
    { label: "Reklamační řád", href: "/complaints_procedure.pdf", external: true },
    { label: "Zásady ochrany osobních údajů", href: "/privacy.pdf", external: true },
];

function CookieResetButton() {
    const handleReset = () => {
        try {
            localStorage.removeItem(COOKIE_KEY);
        } catch { }
        window.location.reload();
    };

    return (
        <button
            onClick={handleReset}
            className="inline-flex items-center gap-1.5 text-xs text-[#082359] font-medium hover:underline focus:outline-none focus-visible:underline transition-colors"
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5 shrink-0">
                <path fillRule="evenodd" d="M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z" clipRule="evenodd" />
            </svg>
            Změnit nastavení cookies
        </button>
    );
}

export default function LegalInfo({ variant = "footer" }) {
    if (variant === "modal") {
        return (
            <div className="space-y-6">
                <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100 flex-wrap sm:flex-nowrap">
                    <img src="/logo.png" alt="De Vries Group" className="h-8 object-contain shrink-0 mt-0.5" />
                    <div>
                        <p className="text-sm font-semibold text-gray-900">De Vries Group, a.s.</p>
                        <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                            IČ: 08555397 · DIČ: CZ08555397<br />
                            Pobřežní 620/3, Karlín, 186 00 Praha 8
                        </p>
                    </div>
                </div>

                <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Kontakt</p>
                    <div className="space-y-1.5">
                        <a href="tel:+420226281001" className="flex items-center gap-2 text-sm text-gray-700 hover:text-[#082359] transition-colors">
                            <span className="text-gray-400">☎</span> +420 226 281 001
                        </a>
                        <a href="mailto:pohledavky@devriesgroup.cz" className="flex items-center gap-2 text-sm text-gray-700 hover:text-[#082359] transition-colors">
                            <span className="text-gray-400">✉</span> pohledavky@devriesgroup.cz
                        </a>
                        <a href="https://www.devriesgroup.cz" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-gray-700 hover:text-[#082359] transition-colors">
                            <span className="text-gray-400">🌐</span> www.devriesgroup.cz
                        </a>
                    </div>
                </div>

                <div>
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">Právní dokumenty</p>
                    <div className="space-y-1.5">
                        {links.map((l) => (
                            <a
                                key={l.label}
                                href={l.href}
                                target={l.external ? "_blank" : undefined}
                                rel={l.external ? "noopener noreferrer" : undefined}
                                className="flex items-center gap-2 text-sm text-[#082359] hover:underline transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="w-3.5 h-3.5 text-gray-400 shrink-0">
                                    <path fillRule="evenodd" d="M4 2a1.5 1.5 0 0 0-1.5 1.5v9A1.5 1.5 0 0 0 4 14h8a1.5 1.5 0 0 0 1.5-1.5V6.621a1.5 1.5 0 0 0-.44-1.06L9.44 2.439A1.5 1.5 0 0 0 8.378 2H4Zm1 5.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5A.75.75 0 0 1 5 7.75Zm.75 2.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" clipRule="evenodd" />
                                </svg>
                                {l.label}
                            </a>
                        ))}
                    </div>
                </div>

                <div className="pt-1 border-t border-gray-100">
                    <CookieResetButton />
                </div>

                <p className="text-[11px] text-gray-400">
                    © {CURRENT_YEAR} De Vries Group, a.s. Všechna práva vyhrazena.
                </p>
            </div>
        );
    }

    return (
        <footer className="w-full border-t border-gray-200 bg-white mt-auto">
            <div className="max-w-2xl mx-auto px-4 py-6 flex flex-col items-center gap-4 text-center">
                <img src="/logo.png" alt="De Vries Group" className="h-7 object-contain" />

                <div className="text-[11px] text-gray-500 leading-relaxed space-y-0.5">
                    <p className="font-medium text-gray-700">De Vries Group, a.s.</p>
                    <p>IČ: 08555397 · DIČ: CZ08555397</p>
                    <p>Pobřežní 620/3, Karlín, 186 00 Praha 8</p>
                    <p>Tel: +420 226 281 001 · pohledavky@devriesgroup.cz</p>
                </div>

                <div className="flex flex-wrap justify-center gap-x-4 gap-y-1.5">
                    {links.map((l) => (
                        <a
                            key={l.label}
                            href={l.href}
                            target={l.external ? "_blank" : undefined}
                            rel={l.external ? "noopener noreferrer" : undefined}
                            className="text-[11px] text-[#082359] hover:underline transition-colors"
                        >
                            {l.label}
                        </a>
                    ))}
                </div>

                <CookieResetButton />

                <p className="text-[10px] text-gray-400">
                    © {CURRENT_YEAR} De Vries Group, a.s. Všechna práva vyhrazena.
                </p>
            </div>
        </footer>
    );
}
